import { slicedToArray as _slicedToArray, toConsumableArray as _toConsumableArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { useState, useRef, useEffect } from 'react';
import 'uuid';
import { IlIcon } from '../IlIcon/index.js';
import IlDataTableV3Pagination from './IlDataTableV3Pagination.js';
import { IlSkeletonText } from '../IlSkeletons/IlSkeletonText/index.js';
import { TableBatchActions, TableBatchAction } from 'carbon-components-react';
import { IlOverflowMenu } from '../IlOverflowMenu/IlOverflowMenu/index.js';
import { IlOverflowMenuItem } from '../IlOverflowMenu/IlOverflowMenuItem/index.js';
import IlDataTableV3Checkbox from './IlDataTableV3Checkbox.js';
import '../IlButton/index.js';
import { createPortal } from 'react-dom';
import IlDataTableV3ContextMenu from './IlDataTableV3ContextMenu.js';
import classNames from 'classnames';

function IlDataTableV3Expanding(props) {
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    searchTerm = _useState2[0],
    setSearchTerm = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    selectAllIsChecked = _useState4[0],
    setSelectAllIsChecked = _useState4[1];
  var _useState5 = useState(props.selectedIds || []),
    _useState6 = _slicedToArray(_useState5, 2),
    selectedIds = _useState6[0],
    setSelectedIds = _useState6[1];
  var _useState7 = useState(props.deselectedIds || []),
    _useState8 = _slicedToArray(_useState7, 2),
    deselectedIds = _useState8[0],
    setDeselectedIds = _useState8[1];
  var _useState9 = useState(null),
    _useState10 = _slicedToArray(_useState9, 2),
    expandedIndex = _useState10[0],
    setExpandedIndex = _useState10[1];
  var _useState11 = useState(null),
    _useState12 = _slicedToArray(_useState11, 2),
    sortingColumn = _useState12[0],
    setSortingColumn = _useState12[1];
  var _useState13 = useState(null),
    _useState14 = _slicedToArray(_useState13, 2),
    sortingDirection = _useState14[0],
    setSortingDirection = _useState14[1];
  var sortingColumnRef = useRef(sortingColumn);
  var sortingDirectionRef = useRef(sortingDirection);
  var _useState15 = useState(null),
    _useState16 = _slicedToArray(_useState15, 2),
    rightClickedRow = _useState16[0],
    setRightClickedRow = _useState16[1];
  var _useState17 = useState(null),
    _useState18 = _slicedToArray(_useState17, 2),
    rightClickedColumn = _useState18[0],
    setRightClickedColumn = _useState18[1];
  var _useState19 = useState({
      x: 0,
      y: 0
    }),
    _useState20 = _slicedToArray(_useState19, 2),
    rightClickedPosition = _useState20[0],
    setRightClickedPosition = _useState20[1];
  var _useState21 = useState(),
    _useState22 = _slicedToArray(_useState21, 2),
    contextMenuItems = _useState22[0],
    setContextMenuItems = _useState22[1];
  var selectedIdsRef = useRef([]);
  var dataRef = useRef([]);
  var wrapperRef = useRef();
  var _useState23 = useState(false),
    _useState24 = _slicedToArray(_useState23, 2),
    stickyHeader = _useState24[0],
    setStickyHeader = _useState24[1];
  useEffect(function () {
    var handleScroll = function handleScroll(ev) {
      if (ev.target.scrollTop >= 10) {
        setStickyHeader(true);
      } else {
        setStickyHeader(false);
      }
    };
    if (wrapperRef.current) {
      wrapperRef.current.addEventListener('scroll', handleScroll);
    }
    return function () {
      if (wrapperRef.current) {
        wrapperRef.current.removeEventListener('scroll', handleScroll);
      }
    };
  }, []);
  useEffect(function () {
    selectedIdsRef.current = selectedIds;
    dataRef.current = props.data;
  }, [props.data, selectedIds]);
  useEffect(function () {
    props.onGridReady(buildGridApi(), {
      forceFetchData: props.fetchData,
      deselectAll: function deselectAll() {
        setSelectAllIsChecked(false);
        setSelectedIds([]);
      }
    });
  }, []);
  function buildGridApi() {
    return {
      sortController: {
        getSortModel: function getSortModel() {
          if (sortingDirectionRef.current && sortingColumnRef.current) {
            return [{
              sort: sortingDirectionRef.current.toLowerCase(),
              colId: sortingColumnRef.current
            }];
          } else {
            return null;
          }
        }
      },
      getSelectedRows: function getSelectedRows() {
        var rows = [];
        selectedIdsRef.current.forEach(function (id) {
          var found = false;
          dataRef.current.forEach(function (singleData) {
            if (singleData.id === id) {
              rows.push(singleData);
              found = true;
            }
          });
          if (!found) {
            rows.push({
              id: id
            });
          }
        });
        return rows;
      },
      setQuickFilter: function setQuickFilter(text) {
        setSearchTerm(text);
      },
      forEachNodeAfterFilter: function forEachNodeAfterFilter() {},
      paginationGoToPage: function paginationGoToPage() {},
      paginationSetPageSize: function paginationSetPageSize() {},
      getSelectAll: function getSelectAll() {
        return selectAllIsChecked;
      }
    };
  }
  function _renderBatchActionItems() {
    if (!props.batchActionsToolbarItems) {
      return null;
    }
    var items = props.batchActionsToolbarItems;
    if (props.batchActionsToolbarVisibleItems) {
      items = props.batchActionsToolbarItems.slice(0, props.batchActionsToolbarVisibleItems);
    }
    var rendered = [];
    items.forEach(function (item) {
      if (item.items) {
        rendered.push(/*#__PURE__*/React__default.createElement(IlOverflowMenu, {
          className: 'IlBatchActions-SubMenu',
          renderIcon: function renderIcon() {
            return /*#__PURE__*/React__default.createElement("span", {
              style: {
                color: 'white'
              }
            }, item.title, /*#__PURE__*/React__default.createElement(IlIcon, {
              name: "arrow-down-solid"
            }));
          }
        }, item.items.map(function (subItem) {
          return /*#__PURE__*/React__default.createElement(IlOverflowMenuItem, {
            itemText: subItem.title,
            onClick: function onClick(ev) {
              subItem.onClick(ev, buildGridApi());
            }
          });
        })));
      } else {
        rendered.push(/*#__PURE__*/React__default.createElement(TableBatchAction, {
          renderIcon: function renderIcon() {
            return null;
          },
          onClick: function onClick(ev) {
            item.onClick(ev, buildGridApi());
          }
        }, item.title));
      }
    });
    if (props.batchActionsToolbarVisibleItems && props.batchActionsToolbarItems.length > props.batchActionsToolbarVisibleItems) {
      rendered.push(/*#__PURE__*/React__default.createElement(IlOverflowMenu, null, props.batchActionsToolbarItems.slice(props.batchActionsToolbarVisibleItems).map(function (item) {
        return /*#__PURE__*/React__default.createElement(IlOverflowMenuItem, {
          itemText: item.title,
          onClick: function onClick(ev) {
            item.onClick(ev, buildGridApi());
          }
        });
      })));
    }
    return rendered;
  }
  function renderBatchActions() {
    var totalSelected = selectedIds.length;
    if (selectAllIsChecked) {
      if (!props.fetchData) {
        totalSelected = getLocalData().length;
      } else {
        totalSelected = props.totalCount;
      }
    }
    return /*#__PURE__*/React__default.createElement(TableBatchActions, {
      shouldShowBatchActions: !!selectedIds.length || selectAllIsChecked,
      onCancel: function onCancel() {
        setSelectAllIsChecked(false);
        setSelectedIds([]);
      },
      totalSelected: totalSelected
    }, _renderBatchActionItems());
  }
  function selectOrDeselectId(id, row) {
    var newIds = Array.from(selectedIds);
    var newDeselectedIds = _toConsumableArray(deselectedIds);
    if (selectAllIsChecked) {
      if (deselectedIds.indexOf(id) < 0) {
        props.onRowSelected({
          data: row,
          node: {
            selected: false
          }
        });
        newDeselectedIds.push(id);
      } else {
        props.onRowSelected({
          data: row,
          node: {
            selected: true
          }
        });
        newDeselectedIds.splice(deselectedIds.indexOf(id), 1);
      }
      setDeselectedIds(newDeselectedIds);
    } else {
      // Select
      if (selectedIds.indexOf(id) < 0) {
        props.onRowSelected({
          data: row,
          node: {
            selected: true
          }
        });
        newIds.push(id);
      }
      // Deselect
      else {
        props.onRowSelected({
          data: row,
          node: {
            selected: false
          }
        });
        newIds.splice(selectedIds.indexOf(id), 1);
      }
      setSelectedIds(newIds);
      setDeselectedIds([]);
      setSelectAllIsChecked(false);
    }
  }
  function renderColumnHeaders() {
    var selectionCheckboxCell = null;
    if (props.selectable) {
      selectionCheckboxCell = /*#__PURE__*/React__default.createElement("th", {
        style: {
          width: 0
        }
      }, /*#__PURE__*/React__default.createElement(IlDataTableV3Checkbox, {
        checked: selectAllIsChecked,
        indeterminate: !selectAllIsChecked && selectedIds.length,
        onChange: function onChange() {
          var localData = getLocalData();
          var localDataIds = localData.map(function (d) {
            return d.id;
          });
          props.onSelectAllRows(!selectAllIsChecked, localDataIds);
          setSelectAllIsChecked(!selectAllIsChecked);
          setDeselectedIds([]);
          setSelectedIds([]);
        }
      }));
    }
    return [selectionCheckboxCell
    // <th style={{ width: 0 }}></th>,
    ].concat(props.columns.map(function (column, i) {
      var sortingIcon = /*#__PURE__*/React__default.createElement(IlIcon, {
        name: 'gs-arrows-up&downfill',
        size: 16
      });
      if (sortingColumn === column.field) {
        if (sortingDirection === 'ASC') {
          sortingIcon = /*#__PURE__*/React__default.createElement(IlIcon, {
            name: 'gs-arrows-upfill',
            size: 16
          });
        } else {
          sortingIcon = /*#__PURE__*/React__default.createElement(IlIcon, {
            name: 'gs-arrows-downfill',
            size: 16
          });
        }
      }
      if (i === 0) {
        return /*#__PURE__*/React__default.createElement("th", {
          colSpan: 2,
          onClick: function onClick() {
            if (props.sortable || column.sortable) {
              onClickSort(column.field);
            }
          }
        }, /*#__PURE__*/React__default.createElement("div", {
          className: 'IlDataTableV3-Expanding-ColumnHeader'
        }, column.headerComponent ? column.headerComponent() : /*#__PURE__*/React__default.createElement("span", null, column.headerName || column.field), props.sortable || column.sortable ? /*#__PURE__*/React__default.createElement("div", null, sortingIcon) : null));
      } else {
        return /*#__PURE__*/React__default.createElement("th", {
          onClick: function onClick() {
            if (props.sortable || column.sortable) {
              onClickSort(column.field);
            }
          }
        }, /*#__PURE__*/React__default.createElement("div", {
          className: 'IlDataTableV3-Expanding-ColumnHeader'
        }, column.headerComponent ? column.headerComponent() : /*#__PURE__*/React__default.createElement("span", null, column.headerName || column.field), props.sortable || column.sortable ? /*#__PURE__*/React__default.createElement("div", null, sortingIcon) : null));
      }
    }));
  }
  function onClickSort(field) {
    if (sortingColumn === field) {
      if (sortingDirection === 'DESC') {
        setSortingColumn(null);
        sortingColumnRef.current = null;
        setSortingDirection(null);
        sortingDirectionRef.current = null;
      } else {
        setSortingDirection('DESC');
        sortingDirectionRef.current = 'DESC';
      }
    } else {
      setSortingColumn(field);
      sortingColumnRef.current = field;
      setSortingDirection('ASC');
      sortingDirectionRef.current = 'ASC';
    }
    if (props.fetchData) {
      props.fetchData();
    }
  }
  function isChecked(id) {
    if (selectAllIsChecked) {
      return deselectedIds.indexOf(id) < 0;
    } else {
      return selectedIds.indexOf(id) >= 0;
    }
  }
  function getFilteredData(data) {
    return data.map(function (row) {
      if (searchTerm.length) {
        var searchData = [];
        props.columns.forEach(function (column) {
          searchData.push(row[column.field]);
        });
        searchData = searchData.join(' ');
        if (searchData.toLowerCase().indexOf(searchTerm.toLowerCase()) < 0) {
          return null;
        } else {
          return row;
        }
      } else {
        return row;
      }
    });
  }
  function getPaginatedData(data) {
    // if there is no pagination
    // or we are fetching individual pages
    // return the data in its entirety
    if (!props.pagination || props.fetchData) {
      return data;
    } else {
      // otherwise for client-side pagination
      // return the relevant page within the data
      return data.slice(props.page * props.pageSize, props.page * props.pageSize + props.pageSize);
    }
  }
  function getSortedData(data) {
    if (!props.fetchData) {
      if (sortingColumn) {
        if (sortingDirection === 'ASC') {
          return data.sort(function (a, b) {
            if (a[sortingColumn].toLowerCase() > b[sortingColumn].toLowerCase()) {
              return 1;
            } else {
              return -1;
            }
          });
        } else {
          return data.sort(function (a, b) {
            if (a[sortingColumn].toLowerCase() < b[sortingColumn].toLowerCase()) {
              return 1;
            } else {
              return -1;
            }
          });
        }
      } else {
        return data;
      }
    } else {
      return data;
    }
  }
  function getLocalData() {
    return getPaginatedData(getSortedData(getFilteredData(props.data).filter(function (x) {
      return !!x;
    })));
  }
  function renderRows() {
    if (props.loading) {
      var loadingRows = [];
      var _loop = function _loop() {
        var loadingRow = [/*#__PURE__*/React__default.createElement("td", {
          className: 'row-control'
        })];
        props.columns.forEach(function () {
          loadingRow.push(/*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("div", {
            style: {
              background: 'red',
              display: 'flex',
              alignItems: 'center'
            }
          }, /*#__PURE__*/React__default.createElement(IlSkeletonText, {
            width: '100%'
          }))));
        });
        loadingRows.push(/*#__PURE__*/React__default.createElement("tr", {
          className: i % 2 ? 'even' : 'odd'
        }, loadingRow));
      };
      for (var i = 0; i < props.pageSize; i++) {
        _loop();
      }
      return loadingRows;
    } else {
      var localData = getLocalData();
      return localData.map(function (row, i) {
        var selectionCell = null;
        if (props.selectable) {
          if (props.isRowSelectable(row, i)) {
            selectionCell = /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(IlDataTableV3Checkbox, {
              checked: isChecked(row.id),
              onChange: function onChange() {
                selectOrDeselectId(row.id, row);
              }
            }));
          } else {
            selectionCell = /*#__PURE__*/React__default.createElement("td", null);
          }
        }
        var handleRightClick = function handleRightClick(ev, row, column) {
          if (typeof props.contextMenuItems === 'function') {
            setContextMenuItems(props.contextMenuItems(row, column));
          } else {
            setContextMenuItems(column.contextMenuItems || props.contextMenuItems);
          }
          setRightClickedRow(row);
          setRightClickedColumn(column);
          setRightClickedPosition({
            x: ev.clientX,
            y: ev.clientY
          });
          ev.preventDefault();
        };
        var isRowExpandable = props.columns && props.columns[0].hasExpandingChildren ? props.columns[0].hasExpandingChildren(row) : true;
        var isRowHighlighted = props.highlightedRow && props.highlightedRow === row;
        return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("tr", {
          className: classNames(i % 2 ? 'even' : 'odd', isRowHighlighted ? 'highlighted' : '')
        }, selectionCell, isRowExpandable ? /*#__PURE__*/React__default.createElement("td", {
          className: 'row-control',
          style: {
            cursor: 'pointer',
            userSelect: 'none'
          },
          onClick: function onClick() {
            if (expandedIndex === i) {
              setExpandedIndex(null);
            } else {
              setExpandedIndex(i);
              props.onExpandRow && props.onExpandRow(row);
            }
          }
        }, expandedIndex === i ? /*#__PURE__*/React__default.createElement(IlIcon, {
          name: 'gs-arrows-down'
        }) : /*#__PURE__*/React__default.createElement(IlIcon, {
          name: 'gs-arrows-right'
        })) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null), props.columns.map(function (column, colIndex) {
          if (column.cellRenderer) {
            return /*#__PURE__*/React__default.createElement("td", {
              colSpan: colIndex === 0 && !isRowExpandable ? 2 : 1,
              className: colIndex === 0 ? 'first' : '',
              onContextMenu: function onContextMenu(ev) {
                return handleRightClick(ev, row, column);
              }
            }, column.cellRenderer({
              value: row[column.field]
            }, row));
          } else {
            return /*#__PURE__*/React__default.createElement("td", {
              colSpan: colIndex === 0 && !isRowExpandable ? 2 : 1,
              className: colIndex === 0 ? 'first' : '',
              onContextMenu: function onContextMenu(ev) {
                return handleRightClick(ev, row, column);
              }
            }, row[column.field]);
          }
        })), expandedIndex === i ? /*#__PURE__*/React__default.createElement("tr", {
          className: classNames('expanded-row', props.expandedRowClass, i % 2 ? 'even' : 'odd')
        }, /*#__PURE__*/React__default.createElement("td", {
          colSpan: props.columns.length + (props.selectable ? 2 : 1)
        }, props.expandedRowRenderer(row, i))) : null);
      });
    }
  }
  function renderPagination() {
    if (!props.pagination) {
      return null;
    } else {
      return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(IlDataTableV3Pagination, {
        page: props.page + 1,
        pageSize: props.pageSize,
        pageSizes: props.pageSizes,
        totalCount: props.totalCount,
        onChange: function onChange(ev) {
          return props.onPaginationChange(ev);
        },
        onFirstPage: function onFirstPage(page) {
          props.setPage(0);
        },
        onNextPage: function onNextPage(page) {
          props.setPage(page + 1);
        },
        onGoToPage: function onGoToPage(page) {
          props.setPage(page);
        },
        onPreviousPage: function onPreviousPage(page) {
          props.setPage(page - 1);
        },
        onLastPage: function onLastPage(page) {
          props.setPage(Math.ceil(props.totalCount / props.pageSize) - 1);
        },
        onChangePageSize: function onChangePageSize(pageSize) {
          props.setPage(0);
          props.setPageSize(pageSize);
        }
      }));
    }
  }
  var style = {};
  if (props.maxTableHeight) {
    style.maxHeight = props.maxTableHeight;
    style.overflowY = 'auto';
  }
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'IlDataTableV3-Expanding'
  }, rightClickedRow || rightClickedColumn ? /*#__PURE__*/createPortal(/*#__PURE__*/React__default.createElement("div", {
    className: 'IlDataTableV3-Expanding--ContextMenuCurtain',
    style: {
      position: 'absolute',
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
      pointerEvents: 'fill'
    },
    onClick: function onClick() {
      setRightClickedRow(null);
      setRightClickedColumn(null);
    }
  }, /*#__PURE__*/React__default.createElement(IlDataTableV3ContextMenu, {
    offset: -10,
    x: rightClickedPosition.x,
    y: rightClickedPosition.y,
    items: contextMenuItems,
    data: rightClickedRow,
    onHide: function onHide() {
      setRightClickedRow(null);
      setRightClickedColumn(null);
    }
  })), document.body) : null, /*#__PURE__*/React__default.createElement("div", {
    style: {
      pointerEvents: selectedIds.length || selectAllIsChecked ? 'all' : 'none',
      height: '50px',
      position: 'absolute',
      top: '-68px',
      width: '100%'
    },
    className: ['IlDataTableV3-BatchActions', selectedIds.length || selectAllIsChecked ? 'visible' : ''].join(' ')
  }, renderBatchActions()), /*#__PURE__*/React__default.createElement("div", {
    className: 'IlDataTableV3--table-wrapper',
    style: style,
    ref: wrapperRef
  }, props.data.length == 0 ? /*#__PURE__*/React__default.createElement("div", null, props.overlayNoRows) : /*#__PURE__*/React__default.createElement("table", null, props.suppressHeader !== true ? /*#__PURE__*/React__default.createElement("thead", {
    className: stickyHeader ? 'IlDataTableV3--sticky-header' : ''
  }, /*#__PURE__*/React__default.createElement("tr", null, renderColumnHeaders())) : null, /*#__PURE__*/React__default.createElement("tbody", null, renderRows()))), renderPagination());
}
IlDataTableV3Expanding.defaultProps = {
  onSelectAllRows: function onSelectAllRows() {},
  isRowSelectable: function isRowSelectable() {
    return true;
  },
  deselectedIds: []
};

export { IlDataTableV3Expanding as default };
